import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrInitialCausality } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrInitialCausality = (
    initialCausality?: PqrInitialCausality
) => {
    const formik = useFormik({
        initialValues: {
            product: '',
            motive: '',
            submotive1: '',
            submotive2: '',
            submotive3: '',
            submotive4: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            product: useGetNameOrValue(initialCausality?.product || ''),
            motive: useGetNameOrValue(initialCausality?.motive || ''),
            submotive1: useGetNameOrValue(
                initialCausality?.submotive1 || 'N/A'
            ),
            submotive2: useGetNameOrValue(
                initialCausality?.submotive2 || 'N/A'
            ),
            submotive3: useGetNameOrValue(
                initialCausality?.submotive3 || 'N/A'
            ),
            submotive4: useGetNameOrValue(
                initialCausality?.submotive4 || 'N/A'
            ),
        });
    }, [initialCausality]);

    return {
        formik,
    };
};
